<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Railmonitor' | mrTranslate }} • {{ name }}</span>
    </div>
    <div class="header-actions">
      <button
        type="button"
        class="btn btn-success"
        style="margin-top: 12px"
        [disabled]="authService.token.rights.status == 1"
        (click)="setImportModal()">
        {{ 'Import' | mrTranslate }}
      </button>

      <clr-dropdown>
        <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu">
          <cds-icon shape="cog" />
        </button>
        <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
          <a (click)="getDimensioning()" clrDropdownItem [class.disabled]="!graphL?.data?.length">
            {{ 'zeige Bemassung' | mrTranslate }}
          </a>
          <a (click)="setSmooth()" clrDropdownItem [class.disabled]="!graphL?.data?.length">
            {{ 'Messwerte glätten' | mrTranslate }}
          </a>
        </clr-dropdown-menu>
      </clr-dropdown>

      <a href="javascript://" class="nav-link nav-icon">
        <cds-icon shape="times" (click)="close()"></cds-icon>
      </a>
    </div>
  </header>
  <div id="profileViewerWrapper">
    <div>
      @if (profiles && sollProfile) {
        <clr-datagrid
          style="max-height: 142px"
          [clrDgSelectionType]="'multi'"
          [(clrDgSelected)]="selected"
          (clrDgSelectedChange)="selectionChanged($event)"
          class="datagrid-compact">
          <clr-dg-column>
            {{ 'Profil' | mrTranslate }}
          </clr-dg-column>
          <clr-dg-column>
            {{ 'Datum' | mrTranslate }}
          </clr-dg-column>
          <clr-dg-column>
            {{ 'Zeit' | mrTranslate }}
          </clr-dg-column>
          <clr-dg-column>
            {{ 'Spurweite' | mrTranslate }}
          </clr-dg-column>
          <clr-dg-column>
            {{ 'Neigung' | mrTranslate }}
          </clr-dg-column>
          <clr-dg-column>
            {{ 'Benutzer' | mrTranslate }}
          </clr-dg-column>
          <clr-dg-column>
            {{ 'Status' | mrTranslate }}
          </clr-dg-column>
          <clr-dg-row *clrDgItems="let row of profiles" [clrDgItem]="row">
            <clr-dg-action-overflow>
              <button class="action-item" (click)="deleteRailMonitor(row.ID)">
                {{ 'Löschen' | mrTranslate }}
              </button>
            </clr-dg-action-overflow>
            <clr-dg-cell>
              {{ row.SollProfil.Bezeichnung }}
            </clr-dg-cell>
            <clr-dg-cell>
              {{ row.MessDatum | tablePrettyPrint }}
            </clr-dg-cell>
            <clr-dg-cell>
              {{ row.MessZeit }}
            </clr-dg-cell>
            <clr-dg-cell>
              {{ row.Spurweite }}
            </clr-dg-cell>
            <clr-dg-cell>
              {{ row.Neigung }}
            </clr-dg-cell>
            <clr-dg-cell>
              {{ row.UserName }}
            </clr-dg-cell>
            <clr-dg-cell>
              {{ row.Status | tablePrettyPrint }}
            </clr-dg-cell>
          </clr-dg-row>
        </clr-datagrid>
      }
    </div>

    @if (graphL.show) {
      <div class="card-block">
        <div class="clr-row">
          <app-plotly-plot
            class="clr-col-6"
            [className]=""
            [data]="graphL.data"
            [layout]="graphL.layout"
            [config]="graphL.config"
            [style]="graphL.style"
            (plotEl)="getPlotID($event, 'l')"></app-plotly-plot>
          <app-plotly-plot
            class="clr-col-6"
            [className]=""
            [data]="graphR.data"
            [layout]="graphR.layout"
            [config]="graphR.config"
            [style]="graphR.style"
            (plotEl)="getPlotID($event, 'r')"></app-plotly-plot>
        </div>
      </div>
    }
  </div>

  <clr-modal [(clrModalOpen)]="showImportModal" [clrModalSize]="'full-screen'" [clrModalClosable]="false">
    <h3 class="modal-title">{{ 'Import Railmonitor' | mrTranslate }} • {{ name }}</h3>
    <div class="modal-body" style="margin-left: 10px">
      <form clrForm clrLayout="horizontal" [formGroup]="modalImportGroup">
        <div class="clr-row">
          <div class="comboboxcontainer clr-form-control clr-row">
            <label class="clr-col-md-2 clr-control-label">{{ 'Sollprofil' | mrTranslate }}</label>
            <div class="clr-control-container clr-col-md-10">
              <input
                class="clr-input combobox"
                id="sollprofil"
                list="sollprofillist"
                name="Option"
                formControlName="sollprofil"
                (change)="loadSoll($event)" />
            </div>
            <datalist id="sollprofillist">
              @for (c of sollProfile | keyvalue; track c) {
                <option [value]="c.key"></option>
              }
            </datalist>
          </div>
          <clr-number-input-container>
            <label>{{ 'Spurweite' | mrTranslate }}</label>
            <input type="number" clrNumberInput formControlName="spurweite" />
          </clr-number-input-container>
          <clr-date-container style="width: 500px">
            <label>{{ 'Messdatum' | mrTranslate }}</label>
            <input
              type="date"
              clrDate
              [ngModel]="modalImportGroup.controls.messdate.value | localeDate"
              (ngModelChange)="modalImportGroup.controls.messdate.setValue(localeDate.tosql($event))"
              [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
          </clr-date-container>

          @if (curSollProfL != undefined) {
            <clr-select-container style="width: 350px">
              <label>{{ 'Neigung' | mrTranslate }}</label>
              <select clrSelect name="options" formControlName="neigung" (change)="onNeigungChanged($event)">
                <option value="0">∞</option>
                <option value="20">1/20</option>
                <option value="40">1/40</option>
              </select>
            </clr-select-container>
          }
        </div>
        <button
          type="button"
          class="btn btn-outline"
          [disabled]="curSollProfL == undefined"
          (click)="importRailmonitor()">
          Import...
        </button>

        <button
          [title]="'MoveUp Links' | mrTranslate"
          type="button"
          (click)="doMove(-moveStepL, 'L', 'Y')"
          class="btn nxr btn-icon btn-primary">
          <cds-icon shape="arrow" direction="up" />
        </button>

        <button
          [title]="'MoveLeft Links' | mrTranslate"
          type="button"
          style="margin-left: 16px"
          (click)="doMove(-moveStepL, 'L', 'X')"
          class="btn nxr btn-icon btn-primary">
          <cds-icon shape="arrow" direction="left" />
        </button>

        <button
          [title]="'MoveRight Links' | mrTranslate"
          type="button"
          style="margin-left: 16px"
          (click)="doMove(moveStepL, 'L', 'X')"
          class="btn nxr btn-icon btn-primary">
          <cds-icon shape="arrow" direction="right" />
        </button>

        <button
          [title]="'MoveDown Links' | mrTranslate"
          type="button"
          style="margin-left: 16px"
          (click)="doMove(moveStepL, 'L', 'Y')"
          class="btn nxr btn-icon btn-primary">
          <cds-icon shape="arrow" direction="down" />
        </button>
        <input
          type="number"
          style="margin-left: 16px; width: 50px"
          value="1.0"
          step="0.1"
          (change)="setMoveStep($event, 'L')"
          class="moveStepL" />
        mm

        <button
          type="button"
          class="btn btn-outline"
          style="margin-left: 75px"
          [disabled]="curSollProfL == undefined"
          (click)="importRailmonitorRechts()">
          Import...
        </button>

        <button
          [title]="'MoveUp Links' | mrTranslate"
          type="button"
          (click)="doMove(-moveStepR, 'R', 'Y')"
          class="btn nxr btn-icon btn-primary">
          <cds-icon shape="arrow" direction="up" />
        </button>

        <button
          [title]="'MoveLeft Links' | mrTranslate"
          type="button"
          style="margin-left: 16px"
          (click)="doMove(-moveStepR, 'R', 'X')"
          class="btn nxr btn-icon btn-primary">
          <cds-icon shape="arrow" direction="left" />
        </button>

        <button
          [title]="'MoveRight Links' | mrTranslate"
          type="button"
          style="margin-left: 16px"
          (click)="doMove(moveStepR, 'R', 'X')"
          class="btn nxr btn-icon btn-primary">
          <cds-icon shape="arrow" direction="right" />
        </button>

        <button
          [title]="'MoveDown Links' | mrTranslate"
          type="button"
          style="margin-left: 16px"
          (click)="doMove(moveStepR, 'R', 'Y')"
          class="btn nxr btn-icon btn-primary">
          <cds-icon shape="arrow" direction="down" />
        </button>

        <input
          type="number"
          style="margin-left: 16px; width: 50px"
          value="1.0"
          step="0.1"
          (change)="setMoveStep($event, 'R')"
          class="moveStepL" />
        mm

        <input
          type="file"
          id="fileUpload"
          name="fileUpload"
          multiple="multiple"
          accept="{{ accept() }}"
          style="display: none"
          (change)="startImport('links')" />
        <input
          type="file"
          id="fileUpload2"
          name="fileUpload2"
          multiple="multiple"
          accept="{{ accept() }}"
          style="display: none"
          (change)="startImport('rechts')" />

        <div class="card-block" style="height: 470px">
          @if (graphL.show) {
            <div class="clr-row">
              <app-plotly-plot
                class="clr-col-6"
                [className]=""
                [data]="graphL.data"
                [layout]="graphL.layout"
                [config]="graphL.config"
                [style]="graphL.style"
                (plotEl)="getPlotID($event, 'l')"></app-plotly-plot>
              <app-plotly-plot
                class="clr-col-6"
                [className]=""
                [data]="graphR.data"
                [layout]="graphR.layout"
                [config]="graphR.config"
                [style]="graphR.style"
                (plotEl)="getPlotID($event, 'r')"></app-plotly-plot>
            </div>
          }
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline" (click)="closeImportModal()">{{ 'Abbrechen' | mrTranslate }}</button>
      <button type="button" class="btn btn-outline" (click)="saveImport()">{{ 'Import speichern' | mrTranslate }}</button>
    </div>
  </clr-modal>
</div>
